<div class="breathing-dot-inner"></div>
